import React from "react";

import brightonio from "../../media/brightonio.png";
import hand from "../../media/mano.png";

const Hero = () => {
  return (
    <section className=" mx-5 mt-24 mb-10 md:m-20 lg:m-28 xl:m-32 2xl:m-40  flex flex-col-reverse gap-2 items-center sm:flex-row">
      <div className="w-full sm:w-1/2 h-full flex flex-col justify-end items-start gap-3">
        <h1 className="text-6xl text-center sm:text-left md:text-6xl lg:text-7xl font-bold font-Bebas text-blue-4 drop-shadow-lg">
          Aprende Inglés con Nosotros
        </h1>
        <p className="text-lg text-center sm:text-left md:text-xl lg:text-2xl text-blue-4 drop-shadow-md max-w-2xl">
          Únete a nuestra comunidad de aprendizaje y domina el inglés con
          nuestros cursos personalizados y profesores expertos.
        </p>
        <button className="bg-primario text-white text-2xl font-semibold font-Bebas px-6 py-3 rounded-lg rounded-tl-none hover:bg-blue-1 transition duration-300 self-center md:self-start shadow-custom-yellow-1">
          Explora Nuestros Cursos
        </button>
      </div>
      <div className="w-full h-[300px] sm:w-1/2 sm:h-screen md:h-fit">
        <div className="h-[300px] sm:h-[500px] xl:h-[550px] w-full rounded-full relative">
          <span className="w-[250px] h-[250px] md:w-[300px] md:h-[300px] lg:w-[400px] lg:h-[400px] xl:w-[500px] xl:h-[500px]  absolute z-0 bg-secundario top-1/2 -translate-y-1/2 xl:bottom-0 left-1/2 -translate-x-1/2 rounded-full border-[5px] border-primario"></span>
          <img
            src={brightonio}
            alt=""
            className="absolute z-10 h-full sm:h-[400px] md:h-[500px]  xl:h-[650px] object-cover md:bottom-[10%] xl:bottom-0"
          />
          <img
            src={hand}
            alt=""
            className="absolute z-10 h-full sm:h-[400px] md:h-[500px]  xl:h-[650px] object-cover md:bottom-[12%] transform md:-translate-y-[12%] xl:bottom-0   left-[2%] md:left-[2%] animate-rotate-5"
          />
          <span className="absolute w-full z-10 bottom-[20%] md:bottom-[30%] md:translate-y-[30%] left-1/2 -translate-x-1/2 translate-y-[20%] text-7xl md:text-8xl xl:text-9xl font-bold font-Bebas text-blue-4 sm:left-1/2 sm:-translate-x-1/2 text-center drop-shadow-lg">
            Brighton
          </span>
          <span className="absolute z-10 bottom-[5%] translate-y-[5%] sm:bottom-[17%] left-1/2 sm:-translate-y-[17%] -translate-x-1/2 w-max text-lg md:text-lg lg:text-2xl xl:text-3xl text-gray-50 bg-blue-4 px-4 py-1 -skew-x-6 -rotate-2 shadow-lg">
            The bridge to your future{" "}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
